import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
  variant?: 'default' | 'inline' | 'overlay';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  text = 'Đang tải...', 
  className = '',
  variant = 'default' 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6', 
    lg: 'h-8 w-8'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  if (variant === 'inline') {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <div className={`animate-spin rounded-full border-2 border-gray-300 border-t-blue-600 ${sizeClasses[size]}`} />
        {text && <span className={`text-gray-600 ${textSizeClasses[size]}`}>{text}</span>}
      </div>
    );
  }

  if (variant === 'overlay') {
    return (
      <div className={`absolute inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-10 ${className}`}>
        <div className="flex items-center gap-3">
          <div className={`animate-spin rounded-full border-2 border-gray-300 border-t-blue-600 ${sizeClasses[size]}`} />
          {text && <span className={`text-gray-700 font-medium ${textSizeClasses[size]}`}>{text}</span>}
        </div>
      </div>
    );
  }

  // Default variant
  return (
    <div className={`flex items-center justify-center py-8 ${className}`}>
      <div className="flex items-center gap-3">
        <div className={`animate-spin rounded-full border-2 border-gray-300 border-t-blue-600 ${sizeClasses[size]}`} />
        {text && <span className={`text-gray-600 ${textSizeClasses[size]}`}>{text}</span>}
      </div>
    </div>
  );
};

// Icon spinner component for buttons
export const ButtonSpinner: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Loader2 className={`animate-spin ${className}`} />
);

export default LoadingSpinner; 